import { render, staticRenderFns } from "./ExportFactorialMaterialModal.vue?vue&type=template&id=38f72832&scoped=true&"
import script from "./ExportFactorialMaterialModal.vue?vue&type=script&lang=js&"
export * from "./ExportFactorialMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./ExportFactorialMaterialModal.vue?vue&type=style&index=0&id=38f72832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f72832",
  null
  
)

component.options.__file = "ExportFactorialMaterialModal.vue"
export default component.exports